import React from 'react'
import styles from "./style.module.css"
import { GetApp } from '@mui/icons-material';

type Props = {
    size: 'small' | 'medium' | 'large';
};

const Downloading: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {

    const { size } = props;

    let properties = {
        spinner: {},
        icon: {}
    };

    switch (size) {
        case 'small':
            properties = {
                spinner: {
                    width: '4vh',
                    height: '4vh',
                    border: '3px solid #f3f3f3',
                    borderTop: '4px solid #3498db'
                },
                icon: {
                    fontSize: '2vh'
                }
            }
            break;
        case 'medium':
            properties = {
                spinner: {
                    width: '8vh',
                    height: '8vh',
                    border: '6px solid #f3f3f3',
                    borderTop: '6px solid #3498db'
                },
                icon: {
                    fontSize: '5vh'
                }
            }
            break;
        case 'large':
            properties = {
                spinner: {
                    width: '13vh',
                    height: '13vh',
                    border: '10px solid #f3f3f3',
                    borderTop: '10px solid #3498db'
                },
                icon: {
                    fontSize: '10vh'
                }
            }
    }

    return (
        <div className={styles.downloading}>
            <GetApp style={properties.icon} className={styles.icon} />
            <div className={styles.spinner} style={properties.spinner}>
            </div>
        </div>
    )
}

export default Downloading
